import { ComponentStyleConfig } from "@chakra-ui/react";

export const formLabel: ComponentStyleConfig = {
  baseStyle: {
    color: "chakra-body-text",
  },
};
